(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["theme-runtime"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = window.Shopify?.routes?.root || '/';
    const html = document.documentElement;
    const catalogMode = html.dataset.catalogMode === 'true';
    const previewHash = html.dataset.previewHash || '';
    const previewInvalid = html.dataset.previewInvalid || '';
    const previewSuccess = html.dataset.previewSuccess || '';
    const accessPath = `${root}pages/preview-access`;
    const currency = document.documentElement.dataset.currency || 'USD';
    const drawer = document.querySelector('[data-cart-layer]');
    const itemsTarget = document.querySelector('[data-cart-items]');
    const summaryTarget = document.querySelector('[data-cart-summary]');
    const countTargets = document.querySelectorAll('[data-cart-count]');
    const escapeHtml = (value) => String(value ?? '').replace(/[&<>'"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#039;', '"': '&quot;' })[character]);
    const money = (cents) => new Intl.NumberFormat('en-US', { style: 'currency', currency, maximumFractionDigits: 0 }).format((Number(cents) || 0) / 100);
    const previewIsUnlocked = () => !catalogMode || html.classList.contains('preview-unlocked');
    const lockPreview = () => {
      try { localStorage.removeItem('nfiPreviewUntil'); } catch (error) {}
      html.classList.remove('preview-unlocked');
    };
    const unlockPreview = () => {
      try { localStorage.setItem('nfiPreviewUntil', String(Date.now() + (12 * 60 * 60 * 1000))); } catch (error) {}
      html.classList.add('preview-unlocked');
    };
    const hashCode = async (value) => {
      const encoded = new TextEncoder().encode(value);
      const result = await crypto.subtle.digest('SHA-256', encoded);
      return Array.from(new Uint8Array(result), (byte) => byte.toString(16).padStart(2, '0')).join('');
    };

    if (catalogMode && !previewIsUnlocked()) lockPreview();

    const setCartOpen = (open) => {
      if (!drawer) return;
      drawer.classList.toggle('open', open);
      drawer.setAttribute('aria-hidden', String(!open));
      document.body.classList.toggle('cart-open', open);
      if (open) drawer.querySelector('[data-cart-close]')?.focus();
    };

    const renderCart = (cart) => {
      countTargets.forEach((target) => { target.textContent = String(cart.item_count || 0); });
      if (!itemsTarget || !summaryTarget) return;
      if (!cart.items?.length) {
        itemsTarget.innerHTML = '<div class="empty-cart"><p>Your cart is empty.</p><a href="/#collection">Shop the collection</a></div>';
        summaryTarget.hidden = true;
        return;
      }
      itemsTarget.innerHTML = cart.items.map((item) => {
        const image = item.featured_image?.url || item.image || '';
        const variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
        return `<article class="cart-item"><a class="cart-item-image" href="${escapeHtml(item.url)}"><img src="${escapeHtml(image)}" alt=""></a><div class="cart-item-copy"><div class="cart-item-topline"><div><a class="cart-item-title" href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a><span class="cart-item-variant">${escapeHtml(variant)}</span></div><strong class="cart-item-price">${money(item.final_line_price ?? item.line_price)}</strong></div><div class="cart-item-actions"><div class="quantity-control"><button type="button" data-cart-change="${escapeHtml(item.key)}" data-quantity="${Math.max(0, item.quantity - 1)}" aria-label="Decrease quantity">−</button><span>${item.quantity}</span><button type="button" data-cart-change="${escapeHtml(item.key)}" data-quantity="${item.quantity + 1}" aria-label="Increase quantity">+</button></div><button type="button" data-cart-change="${escapeHtml(item.key)}" data-quantity="0" aria-label="Remove ${escapeHtml(item.product_title)}">×</button></div></div></article>`;
      }).join('');
      summaryTarget.hidden = false;
      summaryTarget.querySelector('[data-cart-total]').textContent = money(cart.total_price);
    };

    const getCart = async () => {
      const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Cart could not be loaded.');
      const cart = await response.json();
      renderCart(cart);
      return cart;
    };

    const addProduct = async (form, checkout) => {
      const message = form.querySelector('[data-purchase-message]');
      const variant = form.querySelector('input[name="id"]')?.value;
      const quantity = Number(form.querySelector('input[name="quantity"]')?.value || 1);
      if (!variant) {
        if (message) message.textContent = 'Select a size first.';
        return;
      }
      if (message) message.textContent = 'Adding to cart...';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variant), quantity }] })
      });
      const result = await response.json();
      if (!response.ok) {
        if (message) message.textContent = result.description || 'This size could not be added.';
        return;
      }
      await getCart();
      if (checkout) {
        window.location.assign(`${root}checkout`);
      } else {
        if (message) message.textContent = 'Added to your cart.';
        setCartOpen(true);
      }
    };

    document.addEventListener('click', async (event) => {
      const previewExit = event.target.closest('[data-preview-exit]');
      if (previewExit) {
        event.preventDefault();
        lockPreview();
        window.location.assign(root);
        return;
      }
      const restricted = event.target.closest('[data-preview-required]');
      if (restricted && !previewIsUnlocked()) {
        event.preventDefault();
        window.location.assign(accessPath);
        return;
      }
      const open = event.target.closest('[data-cart-open]');
      if (open) { setCartOpen(true); return; }
      const close = event.target.closest('[data-cart-close]');
      if (close) { setCartOpen(false); return; }
      const variantButton = event.target.closest('[data-variant-id]');
      if (variantButton) {
        const form = variantButton.closest('form');
        form.querySelectorAll('[data-variant-id]').forEach((button) => button.classList.remove('selected'));
        variantButton.classList.add('selected');
        form.querySelector('input[name="id"]').value = variantButton.dataset.variantId;
        form.querySelector('[data-purchase-message]').textContent = '';
        return;
      }
      const quantityButton = event.target.closest('[data-product-quantity]');
      if (quantityButton) {
        const form = quantityButton.closest('form');
        const input = form.querySelector('input[name="quantity"]');
        const next = Math.min(10, Math.max(1, Number(input.value || 1) + Number(quantityButton.dataset.productQuantity)));
        input.value = String(next);
        return;
      }
      const buyNow = event.target.closest('[data-buy-now]');
      if (buyNow) {
        event.preventDefault();
        await addProduct(buyNow.closest('form'), true);
        return;
      }
      const change = event.target.closest('[data-cart-change]');
      if (change) {
        change.disabled = true;
        const response = await fetch(`${root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: change.dataset.cartChange, quantity: Number(change.dataset.quantity) })
        });
        const cart = await response.json();
        renderCart(cart);
      }
    });

    document.addEventListener('submit', async (event) => {
      const previewForm = event.target.closest('[data-preview-form]');
      if (previewForm) {
        event.preventDefault();
        const input = previewForm.querySelector('[data-preview-code]');
        const message = previewForm.querySelector('[data-preview-message]');
        const submittedHash = await hashCode(input?.value.trim() || '');
        if (submittedHash !== previewHash) {
          if (message) message.textContent = previewInvalid;
          if (input) input.select();
          return;
        }
        unlockPreview();
        if (message) message.textContent = previewSuccess;
        window.location.assign(root);
        return;
      }
      const form = event.target.closest('[data-product-form]');
      if (!form) return;
      event.preventDefault();
      if (!previewIsUnlocked()) {
        window.location.assign(accessPath);
        return;
      }
      await addProduct(form, false);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') setCartOpen(false);
    });

    getCart().catch(() => {});
  })();
  } catch(e) { console.error(e); }
})();

})();
